import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';


import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {setComponentState,setSidebarState} from '../../actions/Builder.js';
import Notification from '../../components/Notification';
import SidebarElementSpacing from './SidebarElementSpacing.js';

import PaddingPicker from './PaddingPicker.js';
import SidebarElementWrapper from './SidebarElementWrapper.js';
import SidebarElementSetting from './SidebarElementSetting.js';
import SidebarSettingAccordion from './SidebarSettingAccordion.js';

import SidebarElementHeader from './SidebarElementHeader.js';

class Text extends React.Component {
	constructor(props) {
		super(props);
		this.onPaddingChange = this.onPaddingChange.bind(this);
		this.el = this.el.bind(this);
		this.handleBackClick = this.handleBackClick.bind(this);
		this.onChange = this.onChange.bind(this);
		this.componentDidMount = this.componentDidMount.bind(this);
		this.renderEditor = this.renderEditor.bind(this);
		this.instance = false;

		this.state = {
			// Bytt mellom textarea virker ikke. TEkst blir ikke oppdatert.
		}
	}

	onPaddingChange(id,padding) {
		let changes = {};
    	changes[id] = padding;
		this.props.setComponentState(this.el().id,changes);
    }


    el() {
    	return this.props.builder.components[this.props.id];
    }

    renderSettings() {
    	return <div><SidebarElementSpacing text='Settings' />Dette er en test</div>;
    }
    
    handleBackClick() {
    	this.props.setSidebarState({'visible':false});
    }

    onChange(v) {
    	this.props.setComponentState(this.el().id,{value:v});
    }


    renderEditor() {
    	if(this.instance !== false) {
    		this.instance.destroy();
    		this.instance = false;
       	}


    	this.instance = CKEDITOR.replace(this.textInput, {
			customConfig:'/assets/js/ckeditor/editorConfig.js',
			width: '100%',
			height: '100%',
			on: {
		        change: ( evt ) => {
					this.onChange(this.instance.getData());
		        }
		    }
		});
    }

	componentDidMount() {
		if(this.props.sidebar) {
			this.renderEditor();
		}

	}

	componentWillReceiveProps(next) {
		if(this.props.sidebar) {
			if(next.builder.components[next.id].id != this.props.id) {
				this.instance.destroy();
			}
		}
	}


	componentDidUpdate() {
		if(this.props.sidebar) {
			this.renderEditor();
		}
	}

	shouldComponentUpdate(props,state) {
		if(this.props.sidebar && props.id == this.props.id) {
			return false;
		}
		return true;
	}

    render() {
    	if(this.props.sidebar == true) {
    		return(
	    		<div className="sidebar text" style={this.props.style}>
	    			<SidebarElementHeader handleBackClick={this.handleBackClick} text="Text" />
	    				<div className="panel-group panel-group-continuous" id="text-settings" aria-multiselectable="true" role="tablist">

            				<SidebarSettingAccordion selectedSetting={false} optionKey="content" parent="text-settings" title="Content">
            					<textarea ref={(input) => { this.textInput = input; }} onChange={() => null} value={this.el().value}></textarea>
            				</SidebarSettingAccordion>

            				<SidebarSettingAccordion selectedSetting={false} optionKey="padding" parent="text-settings" title="Padding">
            					<PaddingPicker id='padding' handlePaddingChange={this.onPaddingChange} data={this.el().padding} />
            				</SidebarSettingAccordion>
            				</div>
	    		</div>


    		);
    	}else{
    		return (
	      		<div className="text main" style={{textAlign:'left',padding:this.el().padding}} dangerouslySetInnerHTML={{__html:this.el().value}} />
	      );
    	}

    }
}
const mapStateToProps = (state) => {
	return {
		builder:state.builder
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({setComponentState,setSidebarState},dispatch)
}

Text = connect(mapStateToProps,mapDispatchToProps)(Text);

export default Text;





// WEBPACK FOOTER //
// ./components/builder/Text.js